var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"primary-button",class:("primary-button--" + _vm.mode + " " + (_vm.disabled ? 'disabled' : '')),on:{"click":_vm.emitClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }